<template>
    <div>
        <h2>This is the edit component</h2>
    </div>
</template>

<script>
    export default {
        name: "edit"
    }
</script>

<style scoped>

</style>
